export default __webpack_public_path__ + "static/media/prones-ben.06f90241.png";